import { faCheckSquare } from '@fortawesome/free-regular-svg-icons/faCheckSquare';
import { faFolderOpen as farFolderOpen } from '@fortawesome/free-regular-svg-icons/faFolderOpen';
import { faSquare as farSquare } from '@fortawesome/free-regular-svg-icons/faSquare';
import { faTimesCircle as farTimesCircle } from '@fortawesome/free-regular-svg-icons/faTimesCircle';
import { faCaretSquareDown as farCaretSquareDown } from '@fortawesome/free-regular-svg-icons/faCaretSquareDown';

import { faAddressCard } from '@fortawesome/free-solid-svg-icons/faAddressCard';
import { faAlignLeft, faAlignRight, faClock, faMagic, faDolly, faUnlink, faHome, faCreditCard, faQrcode, faBug } from '@fortawesome/free-solid-svg-icons';
import { faAngleLeft } from '@fortawesome/free-solid-svg-icons/faAngleLeft';
import { faAngleRight } from '@fortawesome/free-solid-svg-icons/faAngleRight';
import { faAngleDoubleLeft } from '@fortawesome/free-solid-svg-icons/faAngleDoubleLeft';
import { faAngleDoubleRight } from '@fortawesome/free-solid-svg-icons/faAngleDoubleRight';
import { faArrowDown } from '@fortawesome/free-solid-svg-icons/faArrowDown';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons/faArrowLeft';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons/faArrowRight';
import { faArrowUp } from '@fortawesome/free-solid-svg-icons/faArrowUp';
import { faBan } from '@fortawesome/free-solid-svg-icons/faBan';
import { faBarcode } from '@fortawesome/free-solid-svg-icons/faBarcode';
import { faBars } from '@fortawesome/free-solid-svg-icons/faBars';
import { faBicycle } from '@fortawesome/free-solid-svg-icons/faBicycle';
import { faBiking } from '@fortawesome/free-solid-svg-icons/faBiking';
import { faBrush } from '@fortawesome/free-solid-svg-icons/faBrush';
import { faBox } from '@fortawesome/free-solid-svg-icons/faBox';
import { faBoxOpen } from '@fortawesome/free-solid-svg-icons/faBoxOpen';
import { faBoxes } from '@fortawesome/free-solid-svg-icons/faBoxes';
import { faCalendarAlt } from '@fortawesome/free-solid-svg-icons/faCalendarAlt';
import { faCaretSquareDown } from '@fortawesome/free-solid-svg-icons/faCaretSquareDown';
import { faCashRegister } from '@fortawesome/free-solid-svg-icons/faCashRegister';
import { faCheck } from '@fortawesome/free-solid-svg-icons/faCheck';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons/faCheckCircle';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons/faChevronDown';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons/faChevronLeft';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons/faChevronRight';
import { faChevronUp } from '@fortawesome/free-solid-svg-icons/faChevronUp';
import { faCircle } from '@fortawesome/free-solid-svg-icons/faCircle';
import { faCloudDownloadAlt } from '@fortawesome/free-solid-svg-icons/faCloudDownloadAlt';
import { faCog } from '@fortawesome/free-solid-svg-icons/faCog';
import { faComments } from '@fortawesome/free-solid-svg-icons/faComments';
import { faCopy } from '@fortawesome/free-solid-svg-icons/faCopy';
import { faDownload } from '@fortawesome/free-solid-svg-icons/faDownload';
import { faDesktop } from '@fortawesome/free-solid-svg-icons/faDesktop';
import { faEdit } from '@fortawesome/free-solid-svg-icons/faEdit';
import { faEllipsisV } from '@fortawesome/free-solid-svg-icons/faEllipsisV';
import { faEllipsisH } from '@fortawesome/free-solid-svg-icons/faEllipsisH';
import { faEnvelopeOpenText } from '@fortawesome/free-solid-svg-icons/faEnvelopeOpenText';
import { faEuroSign } from '@fortawesome/free-solid-svg-icons/faEuroSign';
import { faExclamation } from '@fortawesome/free-solid-svg-icons/faExclamation';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons/faExclamationCircle';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons/faExclamationTriangle';
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons/faExternalLinkAlt';
import { faEye } from '@fortawesome/free-solid-svg-icons/faEye';
import { faEyeSlash } from '@fortawesome/free-solid-svg-icons/faEyeSlash';
import { faFile } from '@fortawesome/free-solid-svg-icons/faFile';
import { faFileAlt } from '@fortawesome/free-solid-svg-icons/faFileAlt';
import { faFileExport } from '@fortawesome/free-solid-svg-icons/faFileExport';
import { faFilm } from '@fortawesome/free-solid-svg-icons/faFilm';
import { faFilter } from '@fortawesome/free-solid-svg-icons/faFilter';
import { faFlagCheckered } from '@fortawesome/free-solid-svg-icons/faFlagCheckered';
import { faGripVertical } from '@fortawesome/free-solid-svg-icons/faGripVertical';
import { faFolderOpen as fasFolderOpen } from '@fortawesome/free-solid-svg-icons/faFolderOpen';
import { faHashtag } from '@fortawesome/free-solid-svg-icons/faHashtag';
import { faHistory } from '@fortawesome/free-solid-svg-icons/faHistory';
import { faHourglassHalf } from '@fortawesome/free-solid-svg-icons/faHourglassHalf';
import { faImage } from '@fortawesome/free-solid-svg-icons/faImage';
import { faInfo } from '@fortawesome/free-solid-svg-icons/faInfo';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons/faInfoCircle';
import { faKey } from '@fortawesome/free-solid-svg-icons/faKey';
import { faLink } from '@fortawesome/free-solid-svg-icons/faLink';
import { faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons/faMapMarkerAlt';
import { faMinus } from '@fortawesome/free-solid-svg-icons/faMinus';
import { faMoneyBillWave } from '@fortawesome/free-solid-svg-icons/faMoneyBillWave';
import { faMobileAlt } from '@fortawesome/free-solid-svg-icons/faMobileAlt';
import { faPalette } from '@fortawesome/free-solid-svg-icons/faPalette';
import { faPaperPlane } from '@fortawesome/free-solid-svg-icons/faPaperPlane';
import { faPaperclip } from '@fortawesome/free-solid-svg-icons/faPaperclip';
import { faPaste } from '@fortawesome/free-solid-svg-icons/faPaste';
import { faPencilAlt } from '@fortawesome/free-solid-svg-icons/faPencilAlt';
import { faPeopleArrows } from '@fortawesome/free-solid-svg-icons/faPeopleArrows';
import { faPhoneAlt } from '@fortawesome/free-solid-svg-icons/faPhoneAlt';
import { faPlay } from '@fortawesome/free-solid-svg-icons/faPlay';
import { faPlayCircle } from '@fortawesome/free-solid-svg-icons/faPlayCircle';
import { faPlus } from '@fortawesome/free-solid-svg-icons/faPlus';
import { faPrint } from '@fortawesome/free-solid-svg-icons/faPrint';
import { faQuestion } from '@fortawesome/free-solid-svg-icons/faQuestion';
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons/faQuestionCircle';
import { faRedo } from '@fortawesome/free-solid-svg-icons/faRedo';
import { faReply } from '@fortawesome/free-solid-svg-icons/faReply';
import { faRobot } from '@fortawesome/free-solid-svg-icons/faRobot';
import { faSave } from '@fortawesome/free-solid-svg-icons/faSave';
import { faSearch } from '@fortawesome/free-solid-svg-icons/faSearch';
import { faShare } from '@fortawesome/free-solid-svg-icons/faShare';
import { faShareAlt } from '@fortawesome/free-solid-svg-icons/faShareAlt';
import { faShareSquare } from '@fortawesome/free-solid-svg-icons/faShareSquare';
import { faShippingFast } from '@fortawesome/free-solid-svg-icons/faShippingFast';
import { faShoppingCart } from '@fortawesome/free-solid-svg-icons/faShoppingCart';
import { faSignOutAlt } from '@fortawesome/free-solid-svg-icons/faSignOutAlt';
import { faSmile } from '@fortawesome/free-solid-svg-icons/faSmile';
import { faSnowflake } from '@fortawesome/free-solid-svg-icons/faSnowflake';
import { faSortDown } from '@fortawesome/free-solid-svg-icons/faSortDown';
import { faSortUp } from '@fortawesome/free-solid-svg-icons/faSortUp';
import { faSquare as fasSquare } from '@fortawesome/free-solid-svg-icons/faSquare';
import { faSquareFull } from '@fortawesome/free-solid-svg-icons/faSquareFull';
import { faStar } from '@fortawesome/free-solid-svg-icons/faStar';
import { faSync } from '@fortawesome/free-solid-svg-icons/faSync';
import { faThumbtack } from '@fortawesome/free-solid-svg-icons/faThumbtack';
import { faTimes } from '@fortawesome/free-solid-svg-icons/faTimes';
import { faTimesCircle as fasTimesCircle } from '@fortawesome/free-solid-svg-icons/faTimesCircle';
import { faToggleOff } from '@fortawesome/free-solid-svg-icons/faToggleOff';
import { faToggleOn } from '@fortawesome/free-solid-svg-icons/faToggleOn';
import { faTools } from '@fortawesome/free-solid-svg-icons/faTools';
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons/faTrashAlt';
import { faTruck } from '@fortawesome/free-solid-svg-icons/faTruck';
import { faUndo } from '@fortawesome/free-solid-svg-icons/faUndo';
import { faUndoAlt } from '@fortawesome/free-solid-svg-icons/faUndoAlt';
import { faUnlockAlt } from '@fortawesome/free-solid-svg-icons/faUnlockAlt';
import { faUpload } from '@fortawesome/free-solid-svg-icons/faUpload';
import { faUser } from '@fortawesome/free-solid-svg-icons/faUser';
import { faUserCircle } from '@fortawesome/free-solid-svg-icons/faUserCircle';
import { faUserCog } from '@fortawesome/free-solid-svg-icons/faUserCog';
import { faUserPlus } from '@fortawesome/free-solid-svg-icons/faUserPlus';
import { faVideo } from '@fortawesome/free-solid-svg-icons/faVideo';
import { faLock } from '@fortawesome/free-solid-svg-icons/faLock';
import { faFileInvoice } from '@fortawesome/free-solid-svg-icons/faFileInvoice';
import { faCartArrowDown } from '@fortawesome/free-solid-svg-icons/faCartArrowDown';
import { faPercentage } from '@fortawesome/free-solid-svg-icons/faPercentage';
import { faWifi } from '@fortawesome/free-solid-svg-icons/faWifi';
import { faNotEqual } from '@fortawesome/free-solid-svg-icons/faNotEqual';
import { faSearchDollar } from '@fortawesome/free-solid-svg-icons/faSearchDollar';

export const fontAwesomeIcons = [
    faAddressCard,
    faAlignLeft,
    faAlignRight,
    faAngleLeft,
    faAngleDoubleLeft,
    faAngleRight,
    faAngleDoubleRight,
    faArrowDown,
    faArrowLeft,
    faArrowRight,
    faArrowUp,
    faBan,
    faBarcode,
    faBars,
    faSnowflake,
    faBicycle,
    faBiking,
    faBrush,
    faBox,
    faBoxOpen,
    faBoxes,
    faCalendarAlt,
    faCaretSquareDown,
    farCaretSquareDown,
    faChevronDown,
    faChevronLeft,
    faChevronRight,
    faChevronUp,
    faCloudDownloadAlt,
    faCog,
    faComments,
    faCopy,
    faDesktop,
    faDownload,
    faEdit,
    faEllipsisV,
    faEllipsisH,
    faEnvelopeOpenText,
    faPaperPlane,
    faExclamation,
    faExclamationCircle,
    faExclamationTriangle,
    faExternalLinkAlt,
    faEye,
    faEyeSlash,
    faFile,
    faFileAlt,
    faFileExport,
    faFilm,
    faFilter,
    faFlagCheckered,
    farFolderOpen,
    fasFolderOpen,
    faGripVertical,
    faHashtag,
    faHistory,
    faHourglassHalf,
    faImage,
    faInfo,
    faInfoCircle,
    faKey,
    faLink,
    faUnlink,
    faMapMarkerAlt,
    faMinus,
    faNotEqual,
    faPlus,
    faMobileAlt,
    faPalette,
    faPaperclip,
    faPaste,
    faPencilAlt,
    faPeopleArrows,
    faPhoneAlt,
    faPlay,
    faPlayCircle,
    faPrint,
    faQuestion,
    faQuestionCircle,
    faRobot,
    faSave,
    faSearch,
    faReply,
    faShare,
    faShareAlt,
    faShareSquare,
    faShippingFast,
    faShoppingCart,
    faSignOutAlt,
    faSmile,
    faSortDown,
    faSortUp,
    faStar,
    faThumbtack,
    faToggleOff,
    faToggleOn,
    faTools,
    faTrashAlt,
    faTruck,
    faSync,
    faRedo,
    faUndo,
    faUndoAlt,
    faUnlockAlt,
    faLock,
    faUpload,
    faUser,
    faUserCircle,
    faUserCog,
    faUserPlus,
    faVideo,
    faCheck,
    faTimes,
    faCheckCircle,
    fasTimesCircle,
    faSquareFull,
    fasSquare,
    faCheckSquare,
    farSquare,
    farTimesCircle,
    faCircle,
    faFileInvoice,
    faSearchDollar,
    faEuroSign,
    faMoneyBillWave,
    faCashRegister,
    faPercentage,
    faCartArrowDown,
    faMagic,
    faClock,
    faDolly,
    faWifi,
    faHome,
    faCreditCard,
    faQrcode,
    faBug,
];
